import { Helmet } from "react-helmet-async";

const SITE_NAME = "Evoluras";
const DEFAULT_TITLE = "Evoluras | Personal Development Platform";
const DEFAULT_DESC = "Free personal SWOT analysis, core values assessment, and wheel of life tools. Get honest feedback from the people who know you best.";
const DEFAULT_OG_IMAGE = "/og-image.jpg";

const SEO = ({
  title,
  description,
  path = "",
  type = "website",
  noIndex = false,
  ogImage: ogImageOverride,
  ogImageWidth,
  ogImageHeight,
  // "summary" for square avatar thumbs, "summary_large_image" for banners.
  twitterCard = "summary_large_image",
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const canonicalUrl = `https://evoluras.com${path}`;
  const ogImage = ogImageOverride || `https://evoluras.com${DEFAULT_OG_IMAGE}`;
  // Sensible defaults when caller doesn't override dimensions.
  const imgW = ogImageWidth ?? (twitterCard === "summary" ? 512 : 1200);
  const imgH = ogImageHeight ?? (twitterCard === "summary" ? 512 : 630);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonicalUrl} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content={String(imgW)} />
      <meta property="og:image:height" content={String(imgH)} />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={fullTitle} />
    </Helmet>
  );
};

export default SEO;
